import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wenn ein Hash vorhanden ist (#abschnitt), zu diesem Element scrollen
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView(); // alternativ: {behavior: "smooth"}
        return;
      }
    }
    // Sonst immer ganz nach oben
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
